module.exports = __webpack_public_path__ + "static/media/YB5M10_04.02bfc3b4.jpg";